import React from 'react';
import * as H1 from '../Helper/H1';
import Send from '../Helper/Send';
import { NavLink, useParams, useNavigate } from 'react-router-dom';
import { Message, Input, Form, Schema, Animation, Button } from 'rsuite';


function withParams(Component) {
    return props => <Component {...props} params={useParams()} navigation={useNavigate()} />;
}



export class Diet_Single extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            diet_id: this.props.params.id,
            items: null,
            file: null,
            curent_item: null,
            step: 1,
            week: [

                {
                    name: 'شنبه',
                    slug: 'day_1',
                },
                {
                    name: 'یک شنبه',
                    slug: 'day_2',
                }
                ,
                {
                    name: 'دوشنبه',
                    slug: 'day_3',
                }
                ,
                {
                    name: 'سه‌شنبه',
                    slug: 'day_4',
                }
                ,
                {
                    name: 'چهارشنبه',
                    slug: 'day_5',
                },
                {
                    name: 'پنج‌شنبه',
                    slug: 'day_6',
                },
                {
                    name: 'جمعه',
                    slug: 'day_7',
                }

            ],
        };

    }


    // ---------------- componentDidMount--------------------------

    componentDidMount() {

        Send('page/my/diet/' + this.state.diet_id, "", true).then((res) => {


            if (!res.data.buyed) {
                this.props.navigation('/404');
            }

            this.setState({
                items: res.data.items,
                file: res.data.file,
            });


        }).catch((err) => { });

        H1.NavHide();
    }



    // ---------------- componentWillUnmount--------------------------

    componentWillUnmount() {

        H1.NavShow();
    }



    //------------------ step_change-----------------------

    step_change = (id) => {

        this.setState({ step: id });

    }


    // ---------------- GetDay --------------------------

    GetDay = (theDay) => {
        this.setState({ curent_item: theDay });
        this.step_change(2)
    }






    render() {

        this.state.diet && H1.page_name(this.state.diet.name);

        return !this.state.items ? null : (


            <div className="h-100 mt-4">



                {this.state.step === 1 &&
                    <>


                        <div className='c-row'>


                            <div className="text-center mb-2 py-2 position-relative">

                                <span className="icon-Back fs-3 position-absolute top-50 end-0 translate-middle-y" onClick={() => this.props.navigation(-1)}></span>


                            </div>


                        </div>





                        {!this.state.file &&
                            <div className="c-row mt-4">


                                <Message showIcon type="info">
                                    درخواست رژیم غذایی شما درحال بررسی کارشناس میباشد. و پس از تکمیل شدن در همین بخش  قرار خواهد گرفت.
                                </Message>


                            </div>
                        }




                        {this.state.file &&

                            <div className="c-row mt-4">
                                <Animation.Slide in={true} placement="right">
                                    <>
                                        <div className='fs-3'> برنامه غذایی  </div>
                                        <div className="cc-2 mt-1">ماهانه</div>
                                    </>
                                </Animation.Slide>



                                <Animation.Slide in={true} transitionAppear={true} placement="right">
                                <a target='_blank' href={this.state.file} download> 
                                        <div className='archive_item d-flex flex-row br-16 mt-3 py-3 px-3 bg-white' >
                                            <div className="align-self-center index fs-24 cc-2 me-3 ltr "> </div>
                                            <div className="align-self-center info">
                                                <span className="fw-bold"> دانلود فایل برنامه غذایی</span>
                                            </div>
                                            <div className={`align-self-center ms-auto play cursor cc-1`} >
                                                <span class="icon-Right rotate-180"></span>
                                            </div>
                                        </div>
                                        </a>
                                    </Animation.Slide>





                            </div>
                        }



                    </>
                }






            </div>

        )

    }
}

export default withParams(Diet_Single);
